import { DestinationParams, DestinationParamsState } from '@anm/api/modules/stream/types';
import {
  getFbDescription,
  FB_GROUP_HINT
} from '@anm/components/stream/NewStreamModal/hooks/useSaveDestinationsMetaParams';
import { DestinationWithStreamMeta } from '@anm/components/stream/StreamItem';
import pick from 'lodash/fp/pick';

type FillDestinationsProps = {
  title: string;
  preview?: string;
  fbGroupIds?: string[];
  description?: string;
  destinationIds?: string[];
  destinationParams?: DestinationParamsState;
};

export const getInitialDestinationParams = (
  title: string,
  description: string,
  preview: string,
  destinations?: DestinationWithStreamMeta[]
) =>
  destinations?.reduce((acc, d) => {
    const fields: string[] = [];

    if (d && d.request) {
      const parsedDescription = d.request.description?.replace(FB_GROUP_HINT, '').replace(new RegExp('[\n]+$'), '');

      if (d.request.title === title || !d.request.title) fields.push('title');
      if (d.request.preview === preview || !d.request.preview) fields.push('preview');
      if (parsedDescription === description || !d.request.description) fields.push('description');

      acc[d.id] = { ...d.request };
      acc[d.id]['sameFields'] = fields;
      if (d.request.description?.includes(FB_GROUP_HINT)) acc[d.id]['isFbInstruction'] = true;
    }

    return acc;
  }, {} as DestinationParams);

const getDestinationsParams = ({
  title,
  preview,
  description,
  destinationIds,
  destinationParams = {},
  fbGroupIds = []
}: FillDestinationsProps) => {
  const updatedDestinationsIds = Object.keys(destinationParams);

  const filledDestinationsParams = destinationIds?.reduce((acc, id) => {
    if (destinationParams[id]?.isHidden) return acc;

    if (updatedDestinationsIds.includes(id)) {
      const description = destinationParams[id]?.description;
      const isFbInstruction = destinationParams[id]?.isFbInstruction;

      acc[id] = {
        ...pick(['title', 'preview', 'privacy', 'categoryId', 'transform'], destinationParams[id]),
        description: fbGroupIds.includes(id) && isFbInstruction ? getFbDescription(description) : description || ''
      };
    } else {
      acc[id] = {
        title,
        preview,
        description: fbGroupIds.includes(id) ? getFbDescription(description) : description
      };
    }

    return acc;
  }, {} as DestinationParams);

  return filledDestinationsParams;
};

export default getDestinationsParams;
